import { render, staticRenderFns } from "./donut-c3.vue?vue&type=template&id=6f528240"
import script from "./donut-c3.vue?vue&type=script&lang=js"
export * from "./donut-c3.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports